var map = {
	"./1-1 Meetings.jpg": 6206,
	"./After conference party - U-Fleku.jpg": 5333,
	"./Gala Banquet at Troja Palace.jpg": 8665,
	"./Group Photos.jpg": 8801,
	"./Lunch.jpg": 7661,
	"./Opening Ceremony.jpg": 1949,
	"./Registration.jpg": 5894,
	"./Vintage car journey to the Troja Palace.jpg": 3377,
	"./Welcome Cocktail.jpg": 7303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 846;